class PromotedFilters extends HTMLElement {
  constructor() {
    super();

    this.promotedFilters = [...this.querySelectorAll("[data-promoted-filter]")];
  }

  connectedCallback() {
    this.promotedFilterClickHandler = this.handlePromotedFilterClick.bind(this);
    this.promotedFilters.forEach((filter) => filter.addEventListener("change", this.promotedFilterClickHandler));
    this.filterClickHandler = this.handleFilterClick.bind(this);
    document.addEventListener("theme:filter:clicked", this.filterClickHandler);
  }

  disconnectedCallback() {
    this.promotedFilters.forEach((filter) => filter.removeEventListener("change", this.promotedFilterClickHandler));
    document.removeEventListener("theme:filter:clicked", this.filterClickHandler);
  }

  handlePromotedFilterClick(e) {
    const { target } = e;
    const matchingFilter = document.getElementById(target.dataset.matchingFilter);
    matchingFilter.click();
    target.checked = matchingFilter.checked;
    this.updateShopAllActiveState();
  }

  handleFilterClick(e) {
    const { id, checked } = e.detail;
    if (!id || !id.length) return;
    const matchingPromotedFilter = document.getElementById(`promoted-${id}`);
    matchingPromotedFilter.checked = checked;
    this.updateShopAllActiveState();
  }

  updateShopAllActiveState() {
    const shopAll = this.querySelector(".promoted-filters__item--clear a");
    const isEveryPromotedFilterUnchecked = this.promotedFilters.every((p) => !p.checked);
    shopAll.classList.toggle("active", isEveryPromotedFilterUnchecked);
  }
}

if (customElements.get("promoted-filters") === undefined) customElements.define("promoted-filters", PromotedFilters);
